import { render, staticRenderFns } from "./RFQHistory.vue?vue&type=template&id=bbf83d9c&scoped=true"
import script from "./RFQHistory.vue?vue&type=script&lang=js"
export * from "./RFQHistory.vue?vue&type=script&lang=js"
import style0 from "./RFQHistory.vue?vue&type=style&index=0&id=bbf83d9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf83d9c",
  null
  
)

export default component.exports